import { render } from "./Customfields.vue?vue&type=template&id=0c6bf86a"
import script from "./Customfields.vue?vue&type=script&lang=js"
export * from "./Customfields.vue?vue&type=script&lang=js"

import "./Customfields.vue?vue&type=style&index=0&id=0c6bf86a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__